/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StopwatchIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Stopwatch',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 2h1a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2h1v2h2Z" />
    <path
      d="M19 4a14.94 14.94 0 0 0-9.9 3.729L7.437 6.062l.708-.707A1 1 0 1 0 6.73 3.941l-.707.707-1.414 1.414-.709.708a1 1 0 0 0 1.416 1.414l.707-.707 1.669 1.668A15 15 0 1 0 19 4Zm0 28a13 13 0 1 1 7.833-23.375l-8.925 8.925c-.021.021-.037.04-.057.062a1.858 1.858 0 1 0 2.619 2.635c.023-.021.046-.045.068-.067l8.913-8.912A13 13 0 0 1 19 32Z"
    />
  </svg>`;
};
